import styled from 'styled-components';
import { Colors, Fonts } from '../../config/theme';

type WrapperProps = {
  primary?: boolean;
  border?: boolean;
  width?: string;
  bg?: string;
  lightColor?: boolean;
  color?: string;
};

const Wrapper = styled.button<WrapperProps>`
  padding: 11px 15px;
  color: ${(props: WrapperProps) =>
    props.color !== undefined
      ? props.color
      : props.lightColor
        ? 'var(--color-light)'
        : '#4C6870'};
  background: ${(props: WrapperProps) =>
    props.primary ? Colors.greenMain : 'transparent'};
  background-color: ${(props: WrapperProps) => props.bg};
  width: ${(props: WrapperProps) => props.width};
  font-size: 17px;
  font-weight: 700;
  text-align: center;
  font-family: ${Fonts.secondary}, sans-serif;

  border: ${(props: WrapperProps) =>
    props.border ? ' 3px solid var( --app-color-dark)' : 'none'};
  outline: none;
  border-radius: 4px;
  letter-spacing: 1px;
  transition: 0.4s ease;
  cursor: pointer;

  :hover {
    // background-color: ${(props: WrapperProps) =>
      props.border && 'var(--color-light)'};
    color: 'var(--app-color-dark)';
    box-shadow: ${(props: WrapperProps) =>
      props.border ? '1px 3px 18px rgba(0, 20, 0, 0.9)' : 'none'};
    /* border: ${(props: WrapperProps) =>
      props.border && '1px solid var(--app-color-dark)'}; */
  }
`;

export default Wrapper;
